import { PriceManagerDatapointsModel } from '../../hooks/usePriceManagerDatapointsModel';
import { getVariationPrices, initialVariationPrices } from '../../services';

export const variationPriceQuery = (priceManagerDatapointsModel?: PriceManagerDatapointsModel) => {
  return {
    queryKey: ['variationPrice', priceManagerDatapointsModel],
    queryFn: () => getVariationPrices(priceManagerDatapointsModel),
    initialData: initialVariationPrices,
  };
};
